import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import {
  DEFAULT_TENANT_ID,
  MAIN_GAME_TIMER,
  PRIMARY_COLOR,
  REGISTER_URL,
  SCHOOL_USER_FOR_TOURNAMENT,
  SECONDARY_COLOR,
  TOURNAMENT_ID,
  TOURNAMENT_TYPE,
  extractMonthlyEarnings,
  getDemoFlowData,
  getUserTournamentRegistrationType,
} from "../../../Constants/Commons";
import * as FB from "../../Firebase/FirebaseFunctions";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import { TournamentStatus, returnEncryptedUserId } from "../../utils";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import _, { round, set } from "lodash";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../Loader";
import FormControl from "@mui/material/FormControl";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import InsightsIcon from "@mui/icons-material/Insights";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import Box from "@mui/material/Box";
import { UserStats } from "../Leaderboard/UserStats";
// import "./index.css";
import { useAuth } from "../../../providers/auth-provider";
import { useApp } from "../../../providers/app-provider";
import { MEASURE } from "../../../instrumentation";
import { INSTRUMENTATION_TYPES } from "../../../instrumentation/types";
import AppButton from "../../Common/AppButton";
import { twMerge } from "tailwind-merge";
import ArenaHeader from "../../../GamesArena/Common/ArenaHeader";
import mixpanel from "mixpanel-browser";
import { db } from "../../../firebase-config";
import { Dialog } from "@mui/material";
import CustomizedRating from "../StarRating";
import {
  collection,
  getDocs,
  addDoc,
  query,
  orderBy,
  limit,
  where,
} from "firebase/firestore";
import axios from "axios";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    background: "rgba(0,0,0,0)",
    color: PRIMARY_COLOR,
    border: "1px solid #ced4da",
    fontSize: 12,
    padding: "6px 26px 6px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}));

const ColorButton = styled(Button)(({ theme }) => ({
  color: "black",
  borderRadius: "30px",
  width: "200px",
  backgroundColor: PRIMARY_COLOR,
  fontSize: "calc(0.5vw + 10px) !important",
  "&:hover": {
    backgroundColor: PRIMARY_COLOR,
  },
  fontFamily: "avenir",
}));

const pageHeaders = ["LEADERBOARD", "YOUR STATS"];

const PracticeLeaderboard = (props) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tournamentId = searchParams.get("tId");
  const weeklyQuizParam = searchParams.get("wq");
  const tournamentTitleParam = searchParams.get("t");
  const isDemoGame = searchParams.get("d") === "Y";
  const demoGameId = searchParams.get("gId");
  const redirectToChat = searchParams.get("back");
  const ch1 = searchParams.get("ch");
  const userId = localStorage.getItem("userId");
  const group = searchParams.get("group") ?? "";
  const playedRound = searchParams.get("round");
  const hidePlayedRoundPopup =
    localStorage.getItem("hidePlayedRoundPopup") === "true";
  const postTournamentPractice = searchParams.get("pt") === "Y";
  const currentRound = searchParams.get("r");
  const hideQualificationPopup =
    localStorage.getItem("hideQualificationPopup") === "true";

  const isDemo = searchParams.get("d") === "S";
  const { user: userTemp } = useAuth();
  let user;

  if (isDemo) {
    const userId = localStorage.getItem("userId");
    const firstName = localStorage.getItem("firstName");
    const additionData = getDemoFlowData();
    user = {
      firstName,
      id: userId,
      ...additionData,
    };
  } else {
    user = userTemp;
  }
  const { wallet } = useApp();

  const [data, setData] = useState([]);
  const [roundStatus, setRoundStatus] = useState("COMPLETED");
  const [aggregateOption, setAggregateOption] = useState(0);
  const [aggregateOptionFinal, setAggregateOptionFinal] = useState(3);
  const [tournamentData, setTournamentData] = useState({});
  const [tournamentStatus, setTournamentStatus] = useState("");
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [roundData, setRoundData] = useState({ startDate: {}, endDate: {} });
  const [allRoundData, setAllRoundData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingLeaderboard, setLoadingLeaderboard] = useState(false);
  const [navValue, setNavValue] = useState(0);
  const [didNotPlayError, setDidNotPlayError] = useState(false);
  const [leaderboardLimit, setLeaderboardLimit] = useState(0);
  const [poolLeaderboardData, setPoolLeaderboardData] = useState([]);
  const [pooTournamentData, setPooTournamentData] = useState({});
  const [poolTournamentId, setPoolTournamentId] = useState("");
  const [userPoolData, setUserPoolData] = useState({});
  const [demoUserPlayedRoundOne, setDemoUserPlayedRoundOne] = useState(false);
  const [showPopup, setShowPopup] = useState({ show: false, type: "" });
  const [roundPlayedPopup, setRoundPlayedPopup] = useState({
    show: false,
    header: "",
    body1: "",
    body2: "",
    playedRound: "",
  });
  const [selectedRating, setSelectedRating] = useState(0); // Initialize with a default value if needed
  const [practiceGameLatestAttempt, setPracticeGameLatestAttempt] = useState(
    {}
  );
  const [leaderboradPseudoPosition, setLeaderboradPseudoPosition] = useState(0);
  const [practiceAttemptScore, setPracticeAttemptScore] = useState(0);
  const [practiceAttemptAccuracy, setPracticeAttemptAccuracy] = useState(0);
  const [wouldHaveBeenRank, setWouldHaveBeenRank] = useState(1);
  const [roundBestScore, setRoundBestScore] = useState(0);
  const [registrationPrivacy, setRegistrationPrivacy] = useState({});

  const ELIMINATINFINAL_DROPDOWN_INDEX = 3;
  const QUALIFIERS_DROPDOWN_INDEX = 2;
  const NONELIM_OVERALL_DROPDOWN_INDEX = 0;
  const isTenantIdInTournament = useMemo(() => {
    return (
      getUserTournamentRegistrationType(user, tournamentData?.tenantIds) ===
      SCHOOL_USER_FOR_TOURNAMENT
    );
  }, [tournamentData, user]);

  const youRowRef = useRef(null);

  useEffect(() => {
    // Check that the ref exists and that we are not in the first condition.
    if (youRowRef.current && leaderboradPseudoPosition !== -1) {
      youRowRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [leaderboradPseudoPosition]);

  const fetchRoundDetails = async (tData) => {
    const rounds = [];
    for (let i = 1; i <= +tData.activeRound; i++) {
      let tournamentId = tData.id;
      if (tData.eliminationFinal && (i == 1 || i == 2)) {
        const poolIds = tData.poolIds;
        tournamentId = poolIds.find((p) => user?.registrations.includes(p));
        if (
          postTournamentPractice &&
          (!tournamentId || tournamentId === tData.id)
        ) {
          tournamentId = poolIds[0];
        }
      }
      const data = await getSingleRoundData(i, tournamentId);
      rounds.push(data);
    }
    setAllRoundData(rounds);
  };

  useEffect(() => {
    if (
      data &&
      data.length > 0 &&
      isDemo &&
      demoUserPlayedRoundOne &&
      !hideQualificationPopup
    ) {
      const userRank = data.find((d) => d.id === user.id);
      if (userRank && ["Demo_Pitch_A"].includes(tournamentId)) {
        const rank = userRank?.rank;
        if (rank <= 5) {
          setShowPopup({
            show: true,
            type: "success",
          });
        } else {
          setShowPopup({
            show: true,
            type: "failure",
          });
        }
      }
    }
  }, [data, isDemo, demoUserPlayedRoundOne, hideQualificationPopup]);

  useEffect(() => {
    if (postTournamentPractice) {
      // setAggregateOption(Number(currentRound-1));
      allRoundData.length && handlePracticeChange(Number(currentRound));
      //get the doc with latets endDate in completedPracticeGames
      const queryRef = query(
        collection(db, "children", user?.id, "completedPracticeGames"),
        where("tournamentId", "==", tournamentId),
        orderBy("endTime", "desc"),
        limit(1)
      );

      getDocs(queryRef).then((querySnapshot) => {
        if (querySnapshot.empty) {
          return;
        }
        const game = querySnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }))[0];
        setPracticeGameLatestAttempt(game);
      });
    }
  }, [postTournamentPractice, allRoundData]);

  useEffect(() => {
    if (
      allRoundData &&
      allRoundData.length > 0 &&
      !hidePlayedRoundPopup &&
      playedRound
    ) {
      //get the element in allRoundData with id = playedRound
      const roundData = allRoundData.find((r) => r.id === playedRound);
      if (!roundData?.endRatingPopup) {
        return;
      }
      let header = "";
      let body1 = "";
      let body2 = "";

      switch (playedRound) {
        case "1":
          header = "Round 1 Played";
          body1 = "Ranks may change as more contestants attempt.";
          body2 = "Round 2 timings are 10 AM - 1 PM tomorrow.";

          break;
        case "2":
          header = "Round 2 Played";
          body1 = "Ranks may change before 1 PM as more contestants attempt.";
          body2 = "Finalists will be declared at 1:30 PM";
          break;
        case "3":
          header = "Final Played";
          body1 = "Ranks may change before 5 PM as more contestants attempt.";
          body2 = "Merit list will be declared at 6 PM";
          break;
        default:
          break;
      }
      setRoundPlayedPopup({
        show: true,
        header,
        body1,
        body2,
        playedRound,
      });
    }
  }, [allRoundData, playedRound, hidePlayedRoundPopup]);

  const handleRatingChange = (newValue) => {
    setSelectedRating(newValue);
  };

  // useEffect(() => {
  //   if (data && data.length >0) {
  //     //find the index of the pseudo position of the user based on score and accuracy in practiceGameLatestAttempt

  //     const score = practiceGameLatestAttempt?.score;
  //     const accuracy = (practiceGameLatestAttempt?.attempts ?? 0 )*100/ (practiceGameLatestAttempt?.correctAttempts ?? 1);

  //     let pseudoPosition = data.findIndex((d) => d.score >= score && d.accuracy >= accuracy);

  //     console.log(pseudoPosition, "pseudoPosition");

  //     setLeaderboradPseudoPosition(pseudoPosition);
  //     setPracticeAttemptScore(score);
  //     setPracticeAttemptAccuracy(accuracy);

  //   }
  // }, [data, practiceGameLatestAttempt]);

  useEffect(() => {
    if (data && data.length > 0) {
      const score = practiceGameLatestAttempt?.score;
      const accuracy = Math.floor(
        ((practiceGameLatestAttempt?.correctAttempts ?? 0) * 100) /
          (practiceGameLatestAttempt?.attempts ?? 1)
      );

      let pseudoPosition = -1;
      for (let i = data.length - 1; i >= 0; i--) {
        if (
          data[i].score > score ||
          (data[i].score == score && data[i].accuracy > accuracy)
        ) {
          pseudoPosition = i;
          break;
        }
      }

      setLeaderboradPseudoPosition(pseudoPosition);

      setPracticeAttemptScore(score);
      setPracticeAttemptAccuracy(accuracy);
    }
  }, [data, practiceGameLatestAttempt]);

  const handleStoreRating = async (rating) => {
    if (!rating) return;
    const userRating = {
      rating,
      userId: user.id,
      tournamentId,
      round: playedRound,
      createdAt: new Date(),
    };

    await addDoc(collection(db, "roundRatings"), userRating);
  };

  const renderRoundPlayedPopup = () => {
    return (
      <Dialog
        open={roundPlayedPopup.show}
        onClose={() => {
          setRoundPlayedPopup({
            show: false,
            header: "",
            body1: "",
            body2: "",
            playedRound: "",
          });
          localStorage.setItem("hidePlayedRoundPopup", "true");
          handleStoreRating(selectedRating);
        }}
        className="register-success"
      >
        <div className="relative flex flex-col bg-primary-gradient text-white h-full overflow-hidden px-6 py-6 leading-6 text-base">
          <ul className="my-6 mx-0 flex flex-col mb-0">
            <p className="my-2 mx-0 ml-[-30px] text-center text-[18px] text-[#ccf900]">
              {roundPlayedPopup.header}
            </p>
            <p className="my-0 mx-0 ml-[-30px] text-center">
              {roundPlayedPopup.body1}
            </p>
            <p className="my-0 mx-0 ml-[-30px] text-center text-bold">
              {roundPlayedPopup.body2}
            </p>
          </ul>

          <div className="flex items-center justify-center w-full h-full">
            <CustomizedRating onRatingChange={handleRatingChange} />
          </div>
          <div className="flex items-center justify-center w-full h-full">
            <AppButton
              onClick={() => {
                setRoundPlayedPopup({
                  show: false,
                  header: "",
                  body1: "",
                  body2: "",
                  playedRound: "",
                });
                localStorage.setItem("hidePlayedRoundPopup", "true");
                handleStoreRating(selectedRating);
              }}
              className="rounded-[115px] min-w-[100px] w-[100px] h-[35px] min-h-[35px] self-center items-center  mt-4"
            >
              Proceed
            </AppButton>
          </div>
        </div>
      </Dialog>
    );
  };

  const renderRoundOnePopup = () => {
    return (
      <Dialog
        open={showPopup.show}
        onClose={() => {
          setShowPopup({ show: false, type: "" });
          localStorage.setItem("hideQualificationPopup", "true");
        }}
        className="register-success"
      >
        <div className="relative flex flex-col bg-primary-gradient text-white h-full overflow-hidden px-6 py-6 leading-6 text-base">
          <ul className="my-6 mx-0 flex flex-col gap-4">
            <p className="my-2 mx-0 ml-[-30px] text-center text-[18px] text-[#ccf900]">
              {showPopup.type === "success"
                ? " You're in the Finals!"
                : "Well fought but missed out!"}
            </p>
            <p className="my-2 mx-0 ml-[-30px] text-start">
              {showPopup.type === "success" ? (
                "MEGA JOB! Absolutely aced this round. Find yourself on the leaderboard and flex those brain muscles."
              ) : (
                <>
                  Gave it your all but narrowly missed out! We're sure you'll be
                  back with a bang in the next one.
                  <br />
                  True greats are those who keep showing up at the starting line
                  no matter what!
                </>
              )}
            </p>
          </ul>
          <div className="flex items-center justify-center w-full h-full">
            <AppButton
              onClick={() => {
                setShowPopup({ show: false, type: "" });
                localStorage.setItem("hideQualificationPopup", "true");
              }}
              className="rounded-[115px] min-w-[100px] w-[100px] h-[35px] min-h-[35px] self-center items-center"
            >
              Proceed
            </AppButton>
          </div>
        </div>
      </Dialog>
    );
  };

  const getTournamentDetails = async () => {
    const tData = await FB.getData("tournaments", tournamentId);
    setTournamentData(tData);
    await fetchRoundDetails(tData);
    // FB.getData("tournaments", tournamentId).then((t) => {
    //   setTournamentData(t);
    //   console.log("t", t);
    //   fetchRoundDetails();
    //   // t.setWeeklyQuiz && onNavChange(1);
    // });
  };

  const getSingleRoundData = async (activeRound, tournamentId) => {
    const data = await FB.getData(
      `tournaments/${tournamentId}/rounds`,
      String(activeRound)
    );
    // setRoundData(data);
    return data;
  };

  const setDataByAggregateOption = (
    idx,
    data,
    tournamentData,
    roundData = null,
    eliminationFinal = false,
    postTournamentPractice = false
  ) => {
    const result = [];
    if (
      (eliminationFinal &&
        (idx === ELIMINATINFINAL_DROPDOWN_INDEX + 1 ||
          idx === QUALIFIERS_DROPDOWN_INDEX + 1)) ||
      (!eliminationFinal && idx === NONELIM_OVERALL_DROPDOWN_INDEX)
    ) {
      data.forEach((d) => {
        const aggScore = d.score.reduce((pv, cv) => pv + cv, 0);
        const aggCorrectAttempts = d.correctAttempts.reduce(
          (pv, cv) => pv + cv,
          0
        );
        const aggAttempt = d.attempts.reduce((pv, cv) => pv + cv, 0);
        const aggDaysPlayed = d.daysPlayed?.length ?? 0;
        const aggPoints = d.points?.reduce((pv, cv) => pv + cv, 0);
        let finalRoundScore = 0;
        let round1And2Score = 0;
        let finalAccuracy = 0;
        if (tournamentData?.eliminationFinal) {
          finalRoundScore = d.score[d.score.length - 1];
          round1And2Score = aggScore - finalRoundScore;
          finalAccuracy = Math.floor(
            (Number(d.correctAttempts[d.correctAttempts.length - 1]) * 100) /
              Number(d.attempts[d.attempts.length - 1])
          );
        } else {
          finalAccuracy = Math.floor(
            (Number(aggCorrectAttempts) * 100) / Number(aggAttempt)
          );
        }
        if (!tournamentData?.eliminationFinal || d.round.includes("3")) {
          // condition to check if elimination final round have been played
          result.push({
            name: isDemoGame ? d.playerName : `${d.firstName} ${d.lastName}`,
            grade: d.grade,
            correctAttempts: aggCorrectAttempts,
            city: d.city,
            score: aggScore,
            school: d.school,
            attempts: aggAttempt,
            daysPlayed: aggDaysPlayed,
            pace: Math.floor(
              (MAIN_GAME_TIMER * aggDaysPlayed) / Number(aggAttempt)
            ),
            accuracy: finalAccuracy,
            id: d.id,
            childId: d.childId,
            userId: d.userId,
            points: aggPoints ?? 0,
            finalRoundScore,
            round1And2Score,
          });
        }
      });
    } else {
      data.forEach((d) => {
        const indexPosition = d.round.indexOf(String(idx));
        if (indexPosition > -1) {
          const qId = indexPosition;
          result.push({
            name: isDemoGame ? d.playerName : `${d.firstName} ${d.lastName}`,
            grade: d.grade,
            city: d.city,
            score: d.score[qId],
            attempts: d.attempts[qId],
            correctAttempts: d.correctAttempts[qId],
            daysPlayed: 0,
            pace: Math.floor(MAIN_GAME_TIMER / d.attempts[qId]),
            accuracy: Math.floor(
              (Number(d.correctAttempts[qId]) * 100) / Number(d.attempts[qId])
            ),
            id: d.id,
            childId: d.childId,
            userId: d.userId,
            points: d.points?.[qId] ?? 0,
          });
        }
      });
    }

    let aggregator = tournamentData?.leaderboardAggregator ?? "score";
    if (postTournamentPractice && tournamentData?.eliminationFinal) {
      aggregator = "finalRoundScore";
    }
    const orderedValue = _.orderBy(
      result,
      [aggregator, "accuracy"],
      ["desc", "desc"]
    );

    let rank = 1;
    let diff = 0;
    orderedValue.forEach((d, index) => {
      if (index > 0) {
        if (
          orderedValue[index - 1][aggregator] === d[aggregator] &&
          orderedValue[index - 1].accuracy === d.accuracy
        ) {
          d.rank = rank;
          diff++;
        } else {
          rank = rank + 1 + diff;
          d.rank = rank;
          diff = 0;
        }
      } else {
        d.rank = 1;
      }
      d.coins = tournamentData?.rewardPointsMap?.[d.rank] ?? 0;
      const roundStatus = allRoundData.find((r) => r.status === "IN_PROGRESS");
      let finalPoints = d.points ?? 0;
      if (idx === 0 || roundStatus?.id === String(idx)) {
        const dynamicPoints = roundStatus?.pointsRankMap?.[d.rank] ?? 0;
        finalPoints += dynamicPoints;
      }
      d.points = finalPoints;
    });
    setData(orderedValue);
    const leaderboardLimit = getLeaderboardShowLimit(
      orderedValue,
      tournamentData.leaderboardLimit
    );
    setLeaderboardLimit(leaderboardLimit);
    setLoading(false);
  };

  const getLeaderboardShowLimit = (data, limit) => {
    let showLimit = limit;
    while (
      showLimit < data.length &&
      data[showLimit].rank == data[showLimit - 1].rank
    ) {
      showLimit++;
    }
    return showLimit;
  };

  const fetchLeaderboardDetails = async () => {
    const leaderboardData = await FB.getAllDocs(
      `tournaments/${tournamentId}/leaderboard`,
      isDemo,
      userId
    );
    setLeaderboardData(() => {
      setLoadingLeaderboard(false);
      return leaderboardData;
    });
    // setDataByAggregateOption(0, leaderboardData);
    // setLoading(false);
  };

  const getRoundBestScore = async () => {
    /**const response = await axios.post(`${process.env.REACT_APP_NODE_BASE_URL}/tournamentPractice/get-round-scores`, {
                tournamentId: tId,
                childId: user.id,
                tenantStatus: user.tenantStatus,
            }); */

    const response = await axios.post(
      `${process.env.REACT_APP_NODE_BASE_URL}/tournamentPractice/get-round-highestScore`,
      {
        tournamentId: tournamentId,
        childId: user.id,
        round: currentRound,
        // tenantStatus: user.tenantStatus,
      }
    );
    setRoundBestScore(response.data.data);
  };

  const fetchRegistrationPrivacy = async (tid) => {
    try {
      const registrations = await FB.getAllDocs(
        `tournaments/${tid}/registrations`
      );
      console.warn(
        "registration docs",
        registrations.map((reg) => ({
          docId: reg.id,
          childId: reg.childId,
          userId: reg.userId,
          private: reg.private,
        }))
      );
      const privacyMap = {};
      registrations.forEach((reg) => {
        const registrantId = resolveRegistrantKey(reg);
        if (registrantId) {
          privacyMap[registrantId] = !!reg.private;
        }
      });
      console.error("privacyMap", privacyMap);
      setRegistrationPrivacy(privacyMap);
    } catch (error) {
      console.error("Failed to fetch registration privacy", error);
    }
  };

  const resolveRegistrantKey = (row) => row?.childId || row?.userId || row?.id;

  useEffect(() => {
    setLoading(true);
    setLoadingLeaderboard(true);
    getTournamentDetails();
    fetchLeaderboardDetails();
    getRoundBestScore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!tournamentId) return;
    console.log("mask flag", tournamentData?.maskLeaderboardNames);
    if (!tournamentData?.maskLeaderboardNames) return;
    fetchRegistrationPrivacy(tournamentId);
  }, [tournamentData?.maskLeaderboardNames, tournamentId]);

  const maskedDisplayNames = useMemo(() => {
    if (!tournamentData?.maskLeaderboardNames) return {};
    const map = {};
    let counter = 1;
    data.forEach((row) => {
      const key = resolveRegistrantKey(row);
      const isPrivate = key && registrationPrivacy[key];
      if (isPrivate) {
        if (!map[key]) {
          map[key] = `Player ${counter}`;
          counter += 1;
        }
      } else if (key) {
        map[key] = row.name;
      }
    });
    return map;
  }, [data, registrationPrivacy, tournamentData?.maskLeaderboardNames]);

  const getRowDisplayName = (row) => {
    if (!tournamentData?.maskLeaderboardNames) return row.name;
    const key = resolveRegistrantKey(row);
    const displayName = (key && maskedDisplayNames[key]) ?? row.name;
    if (
      key &&
      key === resolveRegistrantKey(userRankData ?? {}) &&
      registrationPrivacy[key]
    ) {
      return `${displayName} (You)`;
    }
    if (
      key &&
      key === resolveRegistrantKey({ id: user?.id }) &&
      registrationPrivacy[key]
    ) {
      return `${displayName} (You)`;
    }
    return displayName;
  };

  const handlePracticeChange = async (currentRound) => {
    setAggregateOption(currentRound);
    let roundData = null;
    if (currentRound > 0) {
      roundData = allRoundData[currentRound - 1];
      setRoundData(roundData);
    } else {
      // setDataByAggregateOption(event.target.value, leaderboardData);
      setRoundStatus("COMPLETED");
    }
    setDataByAggregateOption(
      currentRound,
      leaderboardData,
      tournamentData,
      roundData
    );
  };

  const handleChange = async (event) => {
    setAggregateOption(event.target.value);
    let roundData = null;
    if (event.target.value > 0) {
      roundData = allRoundData[event.target.value - 1];
      setRoundData(roundData);
    } else {
      // setDataByAggregateOption(event.target.value, leaderboardData);
      setRoundStatus("COMPLETED");
    }
    setDataByAggregateOption(
      event.target.value,
      leaderboardData,
      tournamentData,
      roundData
    );
  };

  const handleFinalChange = async (event) => {
    setAggregateOptionFinal(event.target.value);
    let roundData = null;
    if (event.target.value != 2 && event.target.value != 3) {
      roundData = allRoundData[event.target.value];
      setRoundData(roundData);
    } else {
      setRoundStatus("COMPLETED");
    }
    if (event.target.value !== 3) {
      setDataByAggregateOption(
        event.target.value + 1,
        poolLeaderboardData,
        pooTournamentData,
        roundData,
        true
      );
    } else {
      roundData = allRoundData[event.target.value - 1];
      setRoundData(roundData);
      setDataByAggregateOption(
        event.target.value + 1,
        leaderboardData,
        tournamentData,
        roundData,
        true,
        postTournamentPractice
      );
    }
  };

  const goToCohorts = () => {
    let url = `/leaderboard/cohorts?tId=${tournamentId}`;
    if (redirectToChat) {
      url += `&back=${redirectToChat}&ch=1`;
    }

    if (isDemo) {
      url += `&d=S`;
    }
    navigate(url);
  };

  const onNavChange = (event, newValue) => {
    setNavValue(newValue);
  };

  const getPageTitle = () => {
    if (navValue === 0 && tournamentData.setWeeklyQuiz) {
      return "YOUR STATS";
    }
    return "LEADERBOARD";
  };

  const getUserStatsData = useCallback(() => {
    if (isDemoGame && demoGameId) {
      return leaderboardData.find((d) => d.id === demoGameId) ?? [];
    }
    if (tournamentData.eliminationFinal && userPoolData) {
      //concatinate the data of user from pool and main tournament
      const lData = leaderboardData.find((d) => d.id === user?.id) ?? [];
      const pLData = poolLeaderboardData.find((d) => d.id === user?.id) ?? [];
      for (const [key, value] of Object.entries(pLData)) {
        if (Array.isArray(value)) {
          lData[key] = (lData[key] || []).concat(value);
        }
      }
      return { ...lData };
    } else {
      const lData = leaderboardData.find((d) => d.id === user?.id) ?? [];
      return { ...lData };
    }
  }, [isDemoGame, leaderboardData, userPoolData, tournamentData]);

  const userRankData = useMemo(
    () => data.find((d) => d.id === user?.id),
    [data]
  );

  const didNotPay = useMemo(() => {
    if (userRankData && aggregateOption > 0) {
      return userRankData?.round?.includes(String(aggregateOption));
    }
    return true;
  }, [aggregateOption, userRankData, aggregateOptionFinal]);

  const handleCheckRewards = () => {
    MEASURE(INSTRUMENTATION_TYPES.VIEW_REWARDS, user.id, {});
    navigate("/wallet");
  };

  const handleBack = () => {
    navigate("/completed-tournament-practice-lobby");
  };

  const isPremierTournament = useMemo(() => {
    return user?.premierOpenTournaments?.includes(
      tournamentData?.tournamentNumber
    );
  }, [tournamentData?.tournamentNumber, user?.premierOpenTournaments]);

  const renderRewardsBanner = () => {
    return (
      <div className="mx-2 mt-4">
        <div className="flex gap-2 items-center mb-2">
          <span className="my-0 mt-1">
            <b className="uppercase">Reward system</b>&nbsp;
          </span>
        </div>
        <div className="p-2.5 grid grid-cols-6 bg-primary-gradient text-white rounded-lg items-center">
          <img
            src="/Assets/Icons/trophy.svg"
            alt="trophy"
            className="mr-2 h-12"
          />
          <div className="flex flex-col col-span-3 text-xs text-primary-yellow justify-center">
            <div>Qualify for the finals</div>
            <div>Win Coins</div>
            <div>Redeem against Rewards</div>
          </div>
          <div className="col-span-2 justify-self-end">
            <button
              className=" bg-primary-yellow outline-none border border-solid border-primary-yellow rounded-lg px-[6px] py-[5px] !text-xs w-auto text-[#3a3a3a]"
              onClick={handleCheckRewards}
            >
              Check Rewards
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderWalletSection = () => {
    if (
      !wallet ||
      isTenantIdInTournament ||
      tournamentData?.isQuiz === true ||
      tournamentData?.setWeeklyQuiz === true ||
      !isPremierTournament
    )
      return <></>;
    if (!tournamentData?.rewardPointsMap) {
      if (!isTenantIdInTournament) {
        return renderRewardsBanner();
      }
    }
    const currentMonthFirstThreeLetters = new Date().toLocaleString("default", {
      month: "short",
    });
    let istournamentEnded = tournamentData.isTournamentEnded;
    const { id, isSubscriptionActive } = user;
    const userPointsForToday = data.find((d) => d.id === id)?.coins ?? 0;
    const { monthlyEarnings, rewardPoints } = wallet;
    const earnings = extractMonthlyEarnings(monthlyEarnings);
    const currentMonthsTotalPoints = earnings + userPointsForToday;
    let totalVaultPoints =
      parseInt(currentMonthsTotalPoints) + parseInt(rewardPoints);
    if (isSubscriptionActive) {
      totalVaultPoints = parseInt(rewardPoints) + parseInt(userPointsForToday);
    }
    let endGamePoints;
    if (isSubscriptionActive) {
      endGamePoints = rewardPoints;
    } else {
      endGamePoints = parseInt(earnings) + parseInt(rewardPoints);
    }
    return istournamentEnded ? (
      <div className="mx-2 mt-4 md:w-full md:flex md:flex-col md:items-center">
        <div className="flex gap-2 items-center mb-2">
          <span className="my-0 mt-1">
            <b className="uppercase">Your Winnings</b>&nbsp;
          </span>
        </div>
        <div className="p-2.5 grid grid-cols-2 bg-primary-gradient text-white rounded-lg max-w-[578px] w-full justify-around">
          <div className="space-y-2 ">
            <div className="uppercase text-primary-yellow text-xs text-center">
              This Tournament
            </div>
            <div className="flex justify-center items-center text-xl">
              <img
                src="/Assets/Icons/trophy.svg"
                alt="trophy"
                className="mr-2 h-7"
              />
              {userPointsForToday}
            </div>
          </div>

          <div className="space-y-2">
            <div className="uppercase text-primary-yellow text-xs text-center">
              Vault Balance
            </div>
            <div className="flex justify-center items-center text-xl">
              <img
                src="/Assets/Icons/vault.svg"
                alt="trophy"
                className="mr-2 h-8"
              />
              {rewardPoints}
            </div>
          </div>
        </div>
        <div className="flex gap-2 items-center justify-between mt-4">
          <span className="text-sm uppercase" style={{ fontSize: 12 }}>
            Use vault balance for prizes
          </span>
          <AppButton onClick={handleCheckRewards}>Check Rewards</AppButton>
        </div>
      </div>
    ) : (
      <div className="mx-2 mt-4 md:w-full md:flex md:flex-col md:items-center">
        <div className="flex gap-2 items-center mb-2">
          <span className="my-0 mt-1">
            <b className="uppercase">Projected Winnings</b>&nbsp;
            <span className="text-[10px]">(Based on current rank)</span>
          </span>
        </div>
        <div className="p-2.5 grid grid-cols-2 bg-primary-gradient text-white rounded-lg max-w-[578px] w-full">
          <div className="space-y-2">
            <div className="uppercase text-primary-yellow text-xs text-center">
              Current Rank
            </div>
            <div className="flex justify-center items-center text-xl">
              <img
                src="/Assets/Icons/trophy.svg"
                alt="trophy"
                className="mr-2 h-7"
              />
              {userRankData?.rank ? userRankData?.rank : "--"}
            </div>
          </div>
          <div className="space-y-2">
            <div className="uppercase text-primary-yellow text-xs text-center">
              This Tournament
            </div>
            <div className="flex justify-center items-center text-xl">
              <img
                src="/Assets/Icons/dollar.svg"
                alt="trophy"
                className="mr-2 h-7"
              />
              {userPointsForToday}
            </div>
          </div>
        </div>
        <div className="flex gap-2 items-center justify-between mt-4">
          <span className="text-sm uppercase" style={{ fontSize: 12 }}>
            Use vault balance for prizes
          </span>
          <AppButton
            // className=" bg-primary-yellow outline-none border border-solid border-primary-yellow rounded-lg px-[6px] py-[5px] !text-xs w-[140px] text-[#3a3a3a]"
            onClick={handleCheckRewards}
          >
            Check Rewards
          </AppButton>
        </div>
      </div>
    );
  };

  const renderRegisterButtonSection = () => {
    return (
      <div
        style={{
          margin: "20px 10px 10px 10px",
          color: SECONDARY_COLOR,
        }}
        className={twMerge(
          "flex items-center",
          isDemoGame && demoGameId ? "justify-between" : "justify-center"
        )}
      >
        <b>
          <span className="uppercase md:text-xl">
            {tournamentData.name}
            {/* {tournamentData?.cohorts?.length && !(isDemo && tournamentData?.eliminationFinal)
              ? `: ${tournamentData?.cohortName}`
              : ""} */}
            {currentRound == 1 || currentRound == 2
              ? `: Round ${currentRound}`
              : "Final"}
          </span>
        </b>
        {isDemoGame && demoGameId ? (
          <ColorButton
            onClick={() => {
              window.location.href = REGISTER_URL;
            }}
            variant="contained"
          >
            Register
          </ColorButton>
        ) : null}
      </div>
    );
  };

  const renderFourthColumn = (row) => {
    if (!isDemoGame && isPremierTournament) {
      if (tournamentData?.rewardPointsMap && aggregateOption === 0) {
        return <>{row.coins}</>;
      }
      if (tournamentData?.leaderboardAggregator === "points") {
        return <>{row.points}</>;
      }
    }
    return (
      <>
        {Number.isFinite(row.accuracy) ? row.accuracy : 0}{" "}
        <span style={{ fontSize: 11 }}>%</span>
      </>
    );
  };

  const renderScoreOrPace = (row) => {
    if (postTournamentPractice && currentRound === 3) {
      return (
        <>
          <td className="text-center">{row.finalRoundScore}</td>
        </>
      );
    }
    if (!isDemoGame && aggregateOption !== 0) {
      return <td className="text-center">{row.score}</td>;
    }
    if (tournamentData?.leaderboardAggregator === "points") {
      return <td>{row.points}</td>;
    }

    if (
      tournamentData.carryOverPoints &&
      Object.keys(tournamentData.carryOverPoints)?.length &&
      aggregateOptionFinal === ELIMINATINFINAL_DROPDOWN_INDEX
    ) {
      return (
        <>
          <td className="text-center">{row.round1And2Score}</td>
          <td className="text-center">{row.finalRoundScore}</td>
          <td className="text-center">{row.score}</td>
        </>
      );
    }
    return <td className="text-center">{row.score}</td>;
  };

  const renderThirdColumnHeader = () => {
    let colSpan = 1;
    if (
      tournamentData?.carryOverPoints &&
      Object.keys(tournamentData.carryOverPoints)?.length &&
      aggregateOptionFinal === ELIMINATINFINAL_DROPDOWN_INDEX &&
      !postTournamentPractice
    ) {
      colSpan = 3;
    }
    return (
      <th className="bg-primary-yellow text-black px-1" colSpan={colSpan}>
        {!isDemoGame && aggregateOption !== 0 ? (
          "Score"
        ) : tournamentData?.leaderboardAggregator === "points" ? (
          "Points"
        ) : (
          <>Score</>
        )}
      </th>
    );
  };

  const leaderboardHighlightLimit = () => {
    let showLimit = tournamentData?.numberOfQualifiers ?? 0;
    while (
      showLimit != 0 &&
      showLimit < data.length &&
      data[showLimit].rank == data[showLimit - 1].rank
    ) {
      showLimit++;
    }
    return showLimit;
  };

  const render4thColumnHeader = () => {
    if (!isDemoGame && isPremierTournament) {
      if (tournamentData?.rewardPointsMap && aggregateOption === 0) {
        return "Coins";
      }
      if (tournamentData?.leaderboardAggregator === "points") {
        return "Points";
      }
    }
    return "Accuracy";
  };

  const handlePlayMore = (leaderboardBack = false) => {
    if (leaderboardBack) {
      mixpanel.identify(user.id);
      mixpanel.track("completed_leaderboardBack", {
        tournamentId: tournamentId,
        roundId: currentRound,
      });
    } else {
      mixpanel.identify(user.id);
      mixpanel.track("completed_playMore", {
        tournamentId: tournamentId,
        roundId: currentRound,
      });
    }

    const FinalTournamentId = getFinalTournamentId(tournamentId);
    navigate(`/completed-tournament-practice?tid=${FinalTournamentId}`);
  };

  function getFinalTournamentId(inputStr) {
    const parts = inputStr.split("_");
    // Replace the last part with "Final"
    parts[parts.length - 1] = "Final";
    return parts.join("_");
  }

  return (
    <div className="flex flex-col h-full w-full max-w-3xl items-center justify-center relative bg-white">
      {/* <img
        src="/Assets/Images/pattern-light-desktop.svg"
        alt="vector-pattern"
        className="absolute -z-[1] h-full hidden md:block"
      /> */}
      <ArenaHeader
        goBack={() => handlePlayMore(true)}
        headerText={getPageTitle()}
        nonArenaRoute={true}
      />

      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader />
        </div>
      ) : (
        <div className="h-full w-full overflow-auto">
          {navValue === 0 && !tournamentData.setWeeklyQuiz ? (
            <>
              {renderWalletSection()}
              {renderRegisterButtonSection()}
              {!isDemoGame ? (
                <>
                  {tournamentData?.leaderboardLimit ||
                  tournamentData?.cohorts?.length ? (
                    <div className="w-full bg-[#575757] flex items-center justify-between gap-4 p-2.5 md:px-8 text-white">
                      <span>Personal Best: {roundBestScore}</span>
                      <AppButton
                        className=" min-h-8 h-8"
                        variant="rectangularPrimary"
                        onClick={() => handlePlayMore()}
                      >
                        Play More
                      </AppButton>
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              ) : null}
              <div className="w-full">
                {!isDemoGame && tournamentData?.leaderboardLimit ? (
                  <div className="p-2.5 md:px-8">
                    <span>
                      Simulated Rank:{" "}
                      {leaderboradPseudoPosition < 0
                        ? 1
                        : leaderboradPseudoPosition + 2}
                    </span>
                  </div>
                ) : (
                  <></>
                )}
                <table className="table-auto overflow-auto border-collapse w-[100vw]">
                  <thead className="h-9 text-sm sticky top-0">
                    <tr>
                      <th className="bg-primary-yellow text-black px-1">
                        Rank
                      </th>
                      <th className="bg-primary-yellow text-black px-1">
                        Name
                      </th>
                      {renderThirdColumnHeader()}
                      <th className="bg-primary-yellow text-black px-1">
                        {render4thColumnHeader()}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-[#575757] text-white text-sm w-full">
                    {data.slice(0, leaderboardLimit).map((row, i) => (
                      <React.Fragment key={i}>
                        {leaderboradPseudoPosition === -1 && i == 0 && (
                          <tr
                            key={`pseudo-${i - 1}`}
                            className="bg-[#ccf900]text-black h-[6px]"
                          ></tr>
                        )}
                        {leaderboradPseudoPosition === -1 && i == 0 && (
                          <tr
                            key={`pseudo-${i}`}
                            className="bg-[#ccf900] mt-2 text-black"
                          >
                            <td className="text-center"></td>

                            <td className="">YOU</td>

                            <td className="text-center ml-3">
                              {practiceAttemptScore}
                            </td>

                            <td className="text-center">
                              {practiceAttemptAccuracy}%
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td className="text-center">{row.rank}</td>
                          <td
                            className={twMerge(
                              "pt-2",
                              !isDemoGame &&
                                i < leaderboardHighlightLimit() &&
                                "text-primary-yellow",
                              row.id === user?.id &&
                                registrationPrivacy[
                                  resolveRegistrantKey(row)
                                ] &&
                                "underline font-semibold"
                            )}
                          >
                            {getRowDisplayName(row)}
                          </td>
                          {renderScoreOrPace(row)}
                          <td className="text-center">
                            {renderFourthColumn(row)}
                          </td>
                        </tr>

                        {leaderboradPseudoPosition === i && (
                          <tr
                            key={`pseudo-${i}`}
                            className="bg-[#ccf900] my-2 text-black"
                            ref={youRowRef}
                          >
                            <td className="text-center"></td>

                            <td className="">YOU</td>

                            <td className="text-center ml-3">
                              {practiceAttemptScore}
                            </td>

                            <td className="text-center">
                              {practiceAttemptAccuracy}%
                            </td>
                          </tr>
                        )}

                        {leaderboradPseudoPosition > leaderboardLimit &&
                          i == leaderboardLimit - 1 && (
                            <tr
                              key={`pseudo-${i}`}
                              className="bg-[#ccf900] my-2 text-black"
                              ref={youRowRef}
                            >
                              <td className="text-center"></td>

                              <td className="">YOU</td>

                              <td className="text-center ml-3">
                                {practiceAttemptScore}
                              </td>

                              <td className="text-center">
                                {practiceAttemptAccuracy}%
                              </td>
                            </tr>
                          )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
              {isDemoGame && !demoGameId ? (
                <div
                  style={{
                    width: "100%",
                    paddingTop: 20,
                    display: "flex",
                    position: "absolute",
                    bottom: "-100px",
                    marginBottom: "50px",
                    justifyContent: "center",
                  }}
                >
                  <ColorButton
                    onClick={() => {
                      window.location.href = REGISTER_URL;
                    }}
                    variant="contained"
                  >
                    Register
                  </ColorButton>
                </div>
              ) : null}
            </>
          ) : (
            <div>
              {renderWalletSection()}
              {renderRegisterButtonSection()}
              <UserStats
                tournamentId={tournamentId}
                poolTournamentId={poolTournamentId}
                userPoolData={userPoolData}
                isEliminationFinal={tournamentData.eliminationFinal}
                activeRound={tournamentData.activeRound}
                isDemoGame={isDemoGame}
                data={getUserStatsData()}
                postTournamentPractice={postTournamentPractice}
                currentRound={currentRound}
              />
            </div>
          )}
        </div>
      )}

      {(isDemoGame && demoGameId) ||
      (!isDemoGame && userId && !loading && tournamentData) ? (
        <div className="sticky bottom-0 w-full">
          {!tournamentData.setWeeklyQuiz ? (
            <BottomNavigation
              showLabels
              value={navValue}
              onChange={onNavChange}
              sx={{
                bgcolor: "#3a3a3a",
                "& .Mui-selected": {
                  "& .MuiSvgIcon-root, & .MuiBottomNavigationAction-label": {
                    color: "#ccf900",
                  },
                },
              }}
            >
              <BottomNavigationAction
                label="Leaderboard"
                icon={<EmojiEventsIcon />}
                style={{ color: "#ababab" }}
              />
              <BottomNavigationAction
                label="Your Stats"
                icon={<InsightsIcon />}
                style={{ color: "#ababab" }}
              />
            </BottomNavigation>
          ) : (
            <BottomNavigation
              showLabels
              value={navValue}
              onChange={onNavChange}
              sx={{
                bgcolor: "#3a3a3a",
                "& .Mui-selected": {
                  "& .MuiSvgIcon-root, & .MuiBottomNavigationAction-label": {
                    color: "#ccf900",
                  },
                },
              }}
            >
              <BottomNavigationAction
                label="Your Stats"
                icon={<InsightsIcon />}
                style={{ color: "#ababab" }}
              />
            </BottomNavigation>
          )}
        </div>
      ) : null}
      {renderRoundOnePopup()}
      {renderRoundPlayedPopup()}
    </div>
  );
};

export default PracticeLeaderboard;
